import { render, staticRenderFns } from "./projection-comparison.vue?vue&type=template&id=474b5af4&scoped=true"
import script from "./projection-comparison.vue?vue&type=script&lang=js"
export * from "./projection-comparison.vue?vue&type=script&lang=js"
import style0 from "./projection-comparison.vue?vue&type=style&index=0&id=474b5af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b5af4",
  null
  
)

export default component.exports